<template>
  <div>
    Please use <a :href="loginUrl">the Login link</a> if you aren't forwarded to login page.
  </div>
</template>

<script>
import { useContextStore } from '@/stores/context';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export default {
  setup() {
    const context = useContextStore();
    const route = useRoute();

    // Set the login method to openID
    context.currentLoginMethod = 'auth-openid';

    const returnPath = computed(() => {
      let path = route.query.returnPath || '/';
      if (path === '/auth-openid/login') path = '/';
      return path;
    });

    const loginUrl = computed(() => {
      const query = new URLSearchParams({ returnPath: returnPath.value });
      return `${context.loginRedirectUrl}/api/auth-openid/login?${query.toString()}`;
    });

    window.location.href = loginUrl.value;

    return {
      returnPath,
      loginUrl,
    };
  },
};
</script>
